import { render, staticRenderFns } from "./TeacherNationality.vue?vue&type=template&id=5fec7a6b"
import script from "./TeacherNationality.vue?vue&type=script&lang=js"
export * from "./TeacherNationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fec7a6b')) {
      api.createRecord('5fec7a6b', component.options)
    } else {
      api.reload('5fec7a6b', component.options)
    }
    module.hot.accept("./TeacherNationality.vue?vue&type=template&id=5fec7a6b", function () {
      api.rerender('5fec7a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherNationality.vue"
export default component.exports